import React from "react";
import { Phone, MessageCircle, Layout, MapPin, Smartphone, Layers, Sparkles, Gauge } from "lucide-react";

const ITEMS = [
  { icon: Layout, title: "High-converting landing page", body: "Hero, services, trust, reviews, FAQ, contact — every block tuned for action." },
  { icon: Phone, title: "Click-to-call integration", body: "One-tap dialing from any device — your phone rings while they're still reading." },
  { icon: MessageCircle, title: "WhatsApp booking system", body: "Pre-filled WhatsApp message so patients can book in 2 taps without typing." },
  { icon: Layers, title: "Services showcase", body: "Clear, scannable cards for the treatments and offerings that matter most." },
  { icon: MapPin, title: "Location & contact section", body: "Embedded map, hours, directions, and emergency contact — built for local trust." },
  { icon: Smartphone, title: "Mobile-first design", body: "Designed thumb-first. Looks crisp on a 5-inch phone, scales beautifully to desktop." },
  { icon: Gauge, title: "Speed & SEO basics", body: "Lightweight code, image compression, meta tags — Google-friendly out of the box." },
  { icon: Sparkles, title: "Reviews & trust block", body: "Showcase testimonials, doctor credentials, and social proof to convert skeptics." },
];

export default function WhatYouGet() {
  return (
    <section data-testid="what-you-get-section" className="py-20 lg:py-28 bg-white border-y border-[var(--gf-border)]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.22em] font-bold text-[var(--gf-blue)]">What You Get</p>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08]">
            Everything needed to turn a Google visitor into a booking.
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              data-testid={`get-card-${i}`}
              className="rounded-2xl border border-[var(--gf-border)] p-6 hover:bg-[var(--gf-bg)] hover:-translate-y-1 transition-all"
            >
              <div className="h-11 w-11 rounded-xl bg-[var(--gf-mint)] text-[var(--gf-green-deep)] flex items-center justify-center">
                <it.icon className="h-5 w-5" />
              </div>
              <h3 className="font-display mt-4 text-base font-bold">{it.title}</h3>
              <p className="text-sm text-[var(--gf-text-2)] mt-2 leading-relaxed">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
